// Main Topbar component
// Created as part of ENG2-1700: Create Topbar Component

import React from 'react'
import { Box, Typography } from '@mui/material'
import { tokens } from '../../styles/tokens'
import Breadcrumb from './breadcrumb'
import TopbarActions from './topbar-actions'
import { TopbarProps } from './topbar.types'

const Topbar: React.FC<TopbarProps> = ({ title, breadcrumbs, actions }) => {
  return (
    <Box
      component="header"
      sx={{
        height: `${tokens.layout.topbarHeight}px`,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        padding: '0 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}
    >
      {/* Left side - Title or Breadcrumbs */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        {breadcrumbs && breadcrumbs.length > 0 ? (
          <Breadcrumb items={breadcrumbs} />
        ) : title ? (
          <Typography
            variant="h5"
            sx={{
              fontFamily: '"Montserrat", sans-serif',
              fontSize: '22px',
              fontWeight: 700,
              color: 'text.primary',
              letterSpacing: '-0.3px',
            }}
          >
            {title}
          </Typography>
        ) : null}
      </Box>

      {/* Right side - Actions */}
      {actions && <TopbarActions>{actions}</TopbarActions>}
    </Box>
  )
}

export default Topbar
